import { useEffect, useState } from 'react'

import { liquidValidationDelay } from './constants'

const useLiquidErrors = ({ liquidContent, enabled }) => {
  const [liquidErrors, setLiquidErrors] = useState({})

  useEffect(() => {
    if (!enabled) return

    let isLatestValidation = true

    setTimeout(async () => {
      const { getLiquidErrors } = await import('./helpers')

      if (isLatestValidation) setLiquidErrors(getLiquidErrors(liquidContent))
    }, liquidValidationDelay)

    return () => {
      isLatestValidation = false
    }
  }, [enabled, liquidContent])

  const validateLiquidContent = async () => {
    const { getLiquidErrors } = await import('./helpers')
    const currentLiquidErrors = getLiquidErrors(liquidContent)

    setLiquidErrors(currentLiquidErrors)

    return currentLiquidErrors
  }

  return { liquidErrors, validateLiquidContent }
}

export default useLiquidErrors
